import { render, staticRenderFns } from "./nonPremiumFilesScreen.vue?vue&type=template&id=471c0792&scoped=true&"
import script from "./nonPremiumFilesScreen.vue?vue&type=script&lang=js&"
export * from "./nonPremiumFilesScreen.vue?vue&type=script&lang=js&"
import style0 from "./nonPremiumFilesScreen.vue?vue&type=style&index=0&id=471c0792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c0792",
  null
  
)

export default component.exports